/**
 * Spacing tokens - mathematical scale based on 16px base unit
 * Provides consistent spacing throughout the application
 */

// Base unit derived from common usage in codebase (16px)
const BASE_UNIT = 16;

export const spacingTokens = {
  // Mathematical scale
  xs: BASE_UNIT / 4, // 4px
  sm: BASE_UNIT / 2, // 8px
  md: BASE_UNIT, // 16px (base)
  lg: BASE_UNIT * 1.5, // 24px
  xl: BASE_UNIT * 2, // 32px
  '2xl': BASE_UNIT * 3, // 48px
  '3xl': BASE_UNIT * 4, // 64px
  '4xl': BASE_UNIT * 6, // 96px
  '5xl': BASE_UNIT * 8, // 128px

  // Common UI spacing (mapped to scale)
  none: 0,
  auto: 'auto',

  // Component-specific spacing
  buttonPadding: BASE_UNIT * 0.75, // 12px (common in buttons)
  cardPadding: BASE_UNIT * 1.5, // 24px (common in cards)
  sectionPadding: BASE_UNIT * 2, // 32px (common for sections)
  pageMargin: BASE_UNIT * 3, // 48px (common for page margins)

  // Layout spacing
  containerGap: BASE_UNIT * 1.5, // 24px
  gridGap: BASE_UNIT, // 16px
} as const;

// Helper function for custom multipliers
export const spacing = (multiplier: number) => BASE_UNIT * multiplier;

// Export base unit for reference
export const BASE_SPACING_UNIT = BASE_UNIT;

// Standard border radius — use this instead of hardcoding '8px'
export const BORDER_RADIUS = '8px';

// Prominent floating surfaces (the chat composer and the ballot sheet that
// docks onto it). Matches the 20px the mobile drawer and ballot panel already
// use for their outer corners.
export const BORDER_RADIUS_LG = '20px';

// Semantic shapes retain their proportions independently of surface corners.
export const BORDER_RADIUS_CIRCLE = '50%';
export const BORDER_RADIUS_PILL = '999px';
